import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";

@Component({
  selector: "kl-preference-form",
  templateUrl: "./kl-preference-save-form.component.html",
  styleUrls: ["./kl-preference-save-form.component.scss"],
})
export class KlPreferenceSaveFormComponent implements OnInit {
  @ViewChild("entryModal", { static: true }) public entryModal: any;
  @Input() saveForm = false;
  @Output() onSetPreference = new EventEmitter();
  @Output() onCancelPreference = new EventEmitter();
  entryName: string;
  errorShow: boolean;
  levelStatus: boolean;
  levelDesign: boolean;
  commitType: string;
  type: string;
  id: string;

  public show(commitType: string, type: string, currentData?: any) {
    this.entryModal.show();
    this.type = type;
    this.commitType = commitType;
    if (currentData) {
      this.levelStatus = currentData.level === "APPLICATION";
      this.levelDesign = currentData.level_default === "DEFAULT";
      this.entryName = currentData.description;
    } else {
      this.entryName = "";
      this.levelStatus = false;
      this.levelDesign = false;
    }
  }

  public hide() {
    this.entryModal.hide();
    this.entryName = "";
    this.commitType = "";
    this.type = "";
    this.levelStatus = false;
    this.levelDesign = false;
    this.errorShow = false;
  }

  constructor() {}

  ngOnInit() {}

  setPreference() {
    const preference = {
      entryName: this.entryName,
      commitType: this.commitType,
      levelStatus: this.levelStatus,
      levelDesign: this.levelDesign,
      id: null,
    };
    if (this.id) {
      preference.id = this.id;
    } else {
      delete preference.id;
    }
    this.onSetPreference.emit(preference);
  }
}
